import vtkLineManipulator from './LineManipulator';
import vtkPlaneManipulator from './PlaneManipulator';
import vtkTrackballManipulator from './TrackballManipulator';

export default {
  vtkLineManipulator,
  vtkPlaneManipulator,
  vtkTrackballManipulator,
};
